import { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import DataObject from '@mui/icons-material/DataObject';
import PlaylistAddCheck from '@mui/icons-material/PlaylistAddCheck';
import History from '@mui/icons-material/History';
import Settings from '@mui/icons-material/Settings';
import AuditLogTab from './audit/AuditLogTab';
import { AdminToolsData } from '../../../types/admin';

type ToolsTab = 'audit' | 'database' | 'bulk' | 'config';

interface ToolsTabsProps {
  data: AdminToolsData;
  loading?: boolean;
  onRefresh: () => void;
  onExecuteQuery: (query: string) => Promise<any>;
  onToggleFeatureFlag: (flagId: string) => Promise<{ success: boolean }>;
  onUpdateSystemSetting: (key: string, value: any) => Promise<{ success: boolean }>;
  onRunMaintenanceOperation: (operationId: string) => Promise<{ success: boolean }>;
}

export default function ToolsTabs({
  data,
  loading,
  onRefresh,
}: ToolsTabsProps) {
  const [activeTab, setActiveTab] = useState<ToolsTab>('audit');

  const handleTabChange = (_event: React.SyntheticEvent, newValue: ToolsTab) => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab icon={<History />} label="Audit Log" value="audit" />
        <Tab icon={<DataObject />} label="Database Tools" value="database" disabled />
        <Tab icon={<PlaylistAddCheck />} label="Bulk Operations" value="bulk" disabled />
        <Tab icon={<Settings />} label="System Configuration" value="config" disabled />
      </Tabs>

      {activeTab === 'audit' && (
        <AuditLogTab
          auditLog={data.auditLog}
          auditLogStats={data.auditLogStats}
          loading={loading}
          lastUpdated={data.lastUpdated}
          onRefresh={onRefresh}
        />
      )}

      {/* Database Tools Tab - Coming Soon */}
      {activeTab === 'database' && (
        <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
          Database Tools - Implementation pending
        </Box>
      )}

      {/* Bulk Operations Tab - Coming Soon */}
      {activeTab === 'bulk' && (
        <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
          Bulk Operations - Implementation pending
        </Box>
      )}

      {/* System Configuration Tab - Coming Soon */}
      {activeTab === 'config' && (
        <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
          System Configuration - Implementation pending
        </Box>
      )}
    </Box>
  );
}
